import React from 'react'
import { PageHeading } from 'app/layout/PageHeading'
import { UpcomingEventsWidget } from '../components/Home/UpcomingEventsPanel'

export const EventsPage = () => (
  <section className='bg-white'>
    <PageHeading
      title='Dances & events'
      description='Live music, social dances, and workshops'
      image='getdown/night-owls-1.jpg'
    />
    <UpcomingEventsWidget className='max-w-6xl min-h-screen px-4 py-12 mx-auto sm:px-6' />
  </section>
)
